import { TranslateFn } from 'hooks/useTranslate';
import { Share } from 'types';
import { getEncumbranceLabel } from '../components/PartnerSociety/components/PartnerSocietySharesDetails/utils/getEncumbranceLabel';

export const getShareEncumbranceNames = (
  share: Share,
  partnerId: string,
  translate: TranslateFn
): string => {
  if (!share?.encumbrances || share.encumbrances.length === 0) {
    return translate('NO_ENCUMBRANCES');
  }

  return share.encumbrances
    .map((encumbrance) =>
      encumbrance?.name ? translate(getEncumbranceLabel(encumbrance)) : null
    )
    .join(', ');
};
